import { useEffect, useState } from "react";
import { Button, DatePicker, message, Modal, Select } from "antd";
import { addDocumentToBriefBank } from "../../service/briefBank";

const BRIEF_TYPES = [
  { value: "summary_of_issues", label: "Summary of Issues" },
  { value: "appellants_brief", label: "Appellant's Brief" },
  { value: "appellants_reply", label: "Appellant's Reply" },
  { value: "joint_motion_for_remand", label: "Joint Motion for Remand (JMR)" },
  {
    value: "joint_motion_for_partial_remand",
    label: "Joint Motion for Partial Remand (JMPR)",
  },
];

const apiError = (error, fallback) =>
  error?.response?.data?.error ||
  error?.response?.data?.detail ||
  error?.message ||
  fallback;

export default function AddToBriefBankModal({
  open,
  documentId,
  documentName,
  onClose,
  onAdded,
}) {
  const [practiceArea, setPracticeArea] = useState("va_cavc");
  const [briefType, setBriefType] = useState("");
  const [filedOn, setFiledOn] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setPracticeArea("va_cavc");
    setBriefType("");
    setFiledOn(null);
    setSubmitting(false);
    setError("");
  }, [documentId, open]);

  const submit = async () => {
    if (!documentId || !briefType || !practiceArea || submitting) return;
    setSubmitting(true);
    setError("");
    try {
      const response = await addDocumentToBriefBank(documentId, {
        practice_area: practiceArea,
        brief_type: briefType,
        filed_on: filedOn ? filedOn.format("YYYY-MM-DD") : null,
      });
      message.success("Added to Brief Bank");
      onAdded(response?.data || response);
    } catch (requestError) {
      setError(apiError(requestError, "The document could not be added."));
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Add to Brief Bank"
      onCancel={submitting ? undefined : onClose}
      footer={[
        <Button key="cancel" disabled={submitting} onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="add"
          type="primary"
          loading={submitting}
          disabled={submitting || !briefType || !practiceArea}
          onClick={submit}
        >
          Add and analyze
        </Button>,
      ]}
      destroyOnHidden
    >
      <p>
        Add <strong>{documentName || "this Word document"}</strong> to the
        firm Brief Bank. A same-folder, same-named PDF is detected
        automatically as the Final counterpart.
      </p>
      {error && (
        <div role="alert" style={{ color: "#b42318", marginBottom: 12 }}>
          {error}
        </div>
      )}
      <div style={{ display: "grid", gap: 14 }}>
        <label>
          <div style={{ marginBottom: 5 }}>Practice area</div>
          <Select
            style={{ width: "100%" }}
            value={practiceArea}
            options={[{ value: "va_cavc", label: "VA CAVC" }]}
            onChange={setPracticeArea}
          />
        </label>
        <label>
          <div style={{ marginBottom: 5 }}>Brief type</div>
          <Select
            aria-label="Brief type"
            style={{ width: "100%" }}
            value={briefType || undefined}
            placeholder="Choose brief type"
            options={BRIEF_TYPES}
            onChange={setBriefType}
          />
        </label>
        <label>
          <div style={{ marginBottom: 5 }}>Filing date (optional)</div>
          <DatePicker
            aria-label="Filing date"
            style={{ width: "100%" }}
            value={filedOn}
            onChange={setFiledOn}
          />
        </label>
      </div>
    </Modal>
  );
}
